module.exports = __webpack_public_path__ + "img/3.e52b7349.png";